var _path, _path2, _path3, _path4, _path5, _mask, _ellipse, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRounded(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 60,
    viewBox: "0 0 80 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.3959 17.7195C59.6918 8.20264 15.9595 9.33559 11.6543 17.7195L12.1075 26.7832C12.1075 29.0491 13.9202 28.9585 13.9202 29.5023C13.9202 30.0461 28.7242 31.9948 36.1262 32.9012H43.1506L65.8098 31.0884L67.3959 17.7195Z",
    fill: "white",
    stroke: "#999999",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5345 44.2306C41.9751 46.4723 36.8059 46.1464 27.7423 44.2306L27.5157 44.004L26.6094 43.5509L33.1805 32.901H43.1506L49.7218 31.7681L51.5345 44.2306Z",
    fill: "white",
    stroke: "#999999",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5308 27.4631C35.8029 25.0834 43.2475 25.2202 56.5196 27.4631",
    stroke: "#999999",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6548 18.1724C-11.9115 53.5207 25.4764 58.0526 36.1235 32.9008C22.7571 27.6892 11.4275 23.6106 11.6548 18.1724Z",
    fill: "white",
    stroke: "#999999",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6191 18.1724C91.1854 53.5207 53.7976 58.0526 43.1505 32.9008C56.5168 27.6892 67.8464 23.6106 67.6191 18.1724Z",
    fill: "white",
    stroke: "#999999",
    strokeWidth: 3
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-1_490_38681",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.6839,
    cy: 39.3314,
    rx: 2.26592,
    ry: 2.49251,
    transform: "rotate(16.4185 39.6839 39.3314)"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.6839,
    cy: 39.3314,
    rx: 2.26592,
    ry: 2.49251,
    transform: "rotate(16.4185 39.6839 39.3314)",
    fill: "#999999"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9797 39.1239C38.9939 39.0758 39.0402 38.9868 39.1637 38.9117C39.2926 38.8333 39.5388 38.7596 39.8273 38.8446L38.1314 44.5999C41.173 45.4962 43.9555 43.4653 44.735 40.8198L38.9797 39.1239ZM39.8273 38.8446C40.1158 38.9296 40.2827 39.1251 40.3485 39.2608C40.4115 39.3909 40.4022 39.4907 40.388 39.5389L34.6327 37.843C33.8531 40.4885 35.0897 43.7037 38.1314 44.5999L39.8273 38.8446ZM40.388 39.5389C40.3738 39.587 40.3275 39.676 40.204 39.7511C40.0751 39.8295 39.8289 39.9032 39.5404 39.8182L41.2363 34.0628C38.1947 33.1666 35.4122 35.1975 34.6327 37.843L40.388 39.5389ZM39.5404 39.8182C39.2519 39.7332 39.085 39.5377 39.0192 39.402C38.9562 39.2719 38.9655 39.172 38.9797 39.1239L44.735 40.8198C45.5146 38.1743 44.278 34.9591 41.2363 34.0628L39.5404 39.8182Z",
    fill: "#999999",
    mask: "url(#path-6-inside-1_490_38681)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRounded);
export default __webpack_public_path__ + "static/media/rounded.6ae8422e637bdc2b7e6275ee4fde03a3.svg";
export { ForwardRef as ReactComponent };